import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { customFetchV2 } from '../services/custom-fetch-v2';

interface DeviceAlertRule {
  ruleId: string;
  type: string;
  enabled: boolean;
  params: any;
  lastActivatedAt?: Date | null;
}

type GetDeviceAlertRulesResponse = DeviceAlertRule[];

/**
 * API query to retrieve user info.
 */
const getDeviceAlertRules = async (deviceId: string): Promise<GetDeviceAlertRulesResponse | null> => {
  const response = await customFetchV2<GetDeviceAlertRulesResponse>(`/api/v2/devices/${deviceId}/alert-rules`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('Unable to get device alert rules');
  }

  return response.data;
};

interface UseGetDeviceAlertRulesProps {
  deviceId: string;
}

/**
 * React hook that will fetch and refresh the current logged in user.
 */
const useGetDeviceAlertRules =
  ({ deviceId }: UseGetDeviceAlertRulesProps): UseQueryResult<GetDeviceAlertRulesResponse, unknown> => {
    // If these aren't set then the query will refresh only on mount and refocus
    const refetchProps = {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
    };

    return useQuery(['useGetDeviceAlertRules', deviceId], () => getDeviceAlertRules(deviceId), {
      enabled: true,
      retry: false,
      ...refetchProps,
    });
  };

/** Exports */
export { useGetDeviceAlertRules };
export type { DeviceAlertRule, GetDeviceAlertRulesResponse };

